import { render, staticRenderFns } from "./DFCorrection.vue?vue&type=template&id=5fa84d1c&scoped=true"
import script from "./DFCorrection.vue?vue&type=script&lang=js"
export * from "./DFCorrection.vue?vue&type=script&lang=js"
import style0 from "./DFCorrection.vue?vue&type=style&index=0&id=5fa84d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa84d1c",
  null
  
)

export default component.exports